import { supabase } from './Supabase';

export const getAccessToken = async () => {
    const { data: { session }, error } = await supabase.auth.getSession();

    if (error || !session?.access_token) {
        throw new Error('Your session has expired. Please sign in again.');
    }

    return session.access_token;
};

export const authenticatedApiRequest = async (url, options = {}, suppliedAccessToken = '') => {
    const accessToken = suppliedAccessToken || await getAccessToken();
    const response = await fetch(url, {
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers,
            Authorization: `Bearer ${accessToken}`,
        },
    });

    const contentType = response.headers.get('content-type') || '';
    const payload = contentType.includes('application/json')
        ? await response.json()
        : await response.text();

    if (!response.ok) {
        const message = typeof payload === 'object' ? payload?.error : payload;
        throw new Error(message || `Request failed with status ${response.status}`);
    }

    return payload;
};
